import { render, staticRenderFns } from "./Prediction.vue?vue&type=template&id=51e7c57b&"
import script from "./Prediction.vue?vue&type=script&lang=js&"
export * from "./Prediction.vue?vue&type=script&lang=js&"
import style0 from "./Prediction.vue?vue&type=style&index=0&id=51e7c57b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports